export const CROSS_FLOW_CHANNEL = 'crossFlow';
export enum eventTypes {
	UI = 'ui',
	SCREEN = 'screen',
}
